import React from 'react';
import { BUTTON_STYLES } from '../../constants/styles';
import { ValidationWarning } from '../Messages/StatusMessages';
import SubstitutionBadge from './SubstitutionBadge';

const VeggieSubstitutionSection = ({ order, orderIndex, onVeggieSubstitution, isLocked, saving, autoSubstitution }) => {
    if (!order.veggieOptions || order.veggieOptions.length === 0) {
        return null;
    }

    const showAutoSubBadge = autoSubstitution?.addedId &&
        order.veggieOptions.some(opt => opt.id === autoSubstitution.addedId && opt.isActive);

    const getActiveVeggieCount = () => {
        if (!order.veggieOptions) return null;
        return order.veggieOptions.filter(option => option.isActive).length;
    };

    // Count currently selected veggies
    const selectedVeggieCount = order.veggieOptions.filter(veggie => veggie.isActive).length;
    const totalOriginalVeggie = order.totalOriginalVeggie || 0;
    const maxReached = selectedVeggieCount >= totalOriginalVeggie;

    return (
        <div style={{ marginBottom: '15px' }}>
            <label style={{
                display: 'block',
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: 'bold',
                color: '#555'
            }}>
                Veggies: {totalOriginalVeggie > 0 && `(${selectedVeggieCount}/${totalOriginalVeggie} selected)`}
                {showAutoSubBadge && (
                    <SubstitutionBadge
                        removedName={autoSubstitution.removedName}
                        addedName={autoSubstitution.addedName}
                    />
                )}
            </label>
            {getActiveVeggieCount() !== null && getActiveVeggieCount() !== undefined && getActiveVeggieCount() < 1 && (
                <ValidationWarning message="No Veggie Selected" />
            )}
            <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '8px'
            }}>
                {order.veggieOptions.map((veggieOption, index) => {
                    const isActive = veggieOption.isActive;
                    const isDisabled = isLocked || saving || (maxReached && !isActive);
                    const subs = (veggieOption.subIngredientNames || []).map(s => (s || '').replace(/^SF /, ''));
                    const title = subs.length > 0 ? `${veggieOption.name}: ${subs.join(', ')}` : undefined;

                    return (
                        // Tooltip lives on this wrapper, not the button — Chromium
                        // won't show a title tooltip on a disabled button.
                        <span key={index} title={title}>
                            <button
                                onClick={() => onVeggieSubstitution && onVeggieSubstitution(orderIndex, veggieOption.id, isActive)}
                                disabled={isDisabled}
                                style={BUTTON_STYLES.substitution(isActive, isDisabled)}
                            >
                                <span style={{
                                    marginRight: '4px',
                                    fontSize: '12px'
                                }}>
                                    {isActive ? '✓' : '+'}
                                </span>
                                {veggieOption.name}
                            </button>
                        </span>
                    );
                })}
            </div>
            <div style={{
                fontSize: '12px',
                color: '#6c757d',
                marginTop: '8px'
            }}>
                {maxReached && totalOriginalVeggie > 1 && !isLocked && (
                    <span style={{ color: '#666' }}>
                        Maximum vegetables selected. Remove one to add another.
                    </span>
                )}
            </div>
        </div>
    );
};

export default VeggieSubstitutionSection;